module.exports = __webpack_public_path__ + "static/media/image0.697b6f82.png";